import { render, staticRenderFns } from "./ModalServicos.vue?vue&type=template&id=3198325e&scoped=true&"
import script from "./ModalServicos.vue?vue&type=script&lang=js&"
export * from "./ModalServicos.vue?vue&type=script&lang=js&"
import style0 from "./ModalServicos.vue?vue&type=style&index=0&id=3198325e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198325e",
  null
  
)

export default component.exports